// these sizes are arbitrary and you can set them to whatever you wish
import { css } from 'styled-components'

export const introGutter = '10vmin'

export const colors = {
  black: '#000',
  white: '#fff',
  blue: 'blue',
  mercury: '#E7E7E7',
  mercuryLight: '#f3f3f3',
  alabaster: '#FBFBFB',
  brand: '#D9BB62',
}

export const rhythm = (multiplier = 1) => `${multiplier * 1.5}rem`

export const fonts = {
  special: '"butler", serif',
}

const sizes = {
  ultrawide: 1400,
  wide: 1170,
  desktop: 992,
  tablet: 768,
  phone: 376,
}

// iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((accumulator, label) => {
  // use em in breakpoints to work properly cross-browser and support users
  // changing their browsers font-size: https://zellwk.com/blog/media-query-units/
  const accumulatorC = accumulator
  const emSize = sizes[label] / 16
  accumulatorC[label] = (...args) => css`
    @media (min-width: ${emSize}em) {
      ${css(...args)};
    }
  `
  return accumulatorC
}, {})



// WEBPACK FOOTER //
// ./src/utils/style-utils.js